import React from 'react';
import StatusBadge from '../../common/detail/StatusBadge';
import '../../../css/design/detail.css';
import '../../../css/admin/artists/ArtistPartnerBadge.css';

export default function ArtistPartnerBadge({ enabled, variant = 'badge' }: { enabled?: boolean; variant?: 'badge' | 'icon' }) {
  if (!enabled) return null;
  if (variant === 'icon') return <span className="artist-partner-icon" role="img" aria-label="パートナー" title="パートナー"><i className="fa-solid fa-handshake" aria-hidden="true" /></span>;
  return <StatusBadge tone="success" icon="fa-solid fa-handshake" className="artist-partner-badge">パートナー</StatusBadge>;
}
